/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Payment_Clear_Confirmation_TitleInputs */

const en_case_payment_clear_confirmation_title = /** @type {(inputs: Case_Payment_Clear_Confirmation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove payment confirmation?`)
};

const pt_br2_case_payment_clear_confirmation_title = /** @type {(inputs: Case_Payment_Clear_Confirmation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remover confirmação de pagamento?`)
};

/**
* | output |
* | --- |
* | "Remove payment confirmation?" |
*
* @param {Case_Payment_Clear_Confirmation_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_payment_clear_confirmation_title = /** @type {((inputs?: Case_Payment_Clear_Confirmation_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Payment_Clear_Confirmation_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_payment_clear_confirmation_title(inputs)
	return pt_br2_case_payment_clear_confirmation_title(inputs)
});